import script from "./CustomerCategoryModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerCategoryModal.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerCategoryModal.vue?vue&type=style&index=0&id=1171e05a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1171e05a"]])

export default __exports__